import { render, staticRenderFns } from "./couponRecord.vue?vue&type=template&id=577427c6&scoped=true"
import script from "./couponRecord.vue?vue&type=script&lang=js"
export * from "./couponRecord.vue?vue&type=script&lang=js"
import style0 from "./couponRecord.vue?vue&type=style&index=0&id=577427c6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577427c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('577427c6')) {
      api.createRecord('577427c6', component.options)
    } else {
      api.reload('577427c6', component.options)
    }
    module.hot.accept("./couponRecord.vue?vue&type=template&id=577427c6&scoped=true", function () {
      api.rerender('577427c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformManage/components/couponRecord.vue"
export default component.exports